import React from "react";
import { Container } from "@mui/material";


export default function ResourcesPage() {
  return (
    <Container>hello resource page!</Container>
  );
}